import * as z from "zod";

export const getShipmonkIntegration = {
  name: "getShipmonkIntegration" as const,
  input: z.object({}),
  output: z.object({
    integration: z
      .object({
        storeId: z.string(),
        apiKeyPreview: z.string(),
        sandboxMode: z.boolean(),
      })
      .nullable(),
  }),
};
